// OPTIMIZADOR DE PERFORMANCE PARA PUBLIKAYA
// Mejora Core Web Vitals y reduce tiempo de carga

// Función para actualizar el fondo del hero con cache busting
function updateHeroBackground() {
    const hero = document.querySelector('.hero');
    if (hero) {
        const timestamp = new Date().getTime();
        hero.style.backgroundImage = `url('https://r2-cache.miotroplaneta2008.workers.dev/assets/images/fondo1.webp?nocache=${timestamp}')`;
    }
}

(function() {
  'use strict';
  
  // Configuración de performance
  const PERFORMANCE_CONFIG = {
    lazyLoadOffset: '50px',
    debounceDelay: 100,
    intersectionThreshold: 0.1
  };
  
  // Optimización de imágenes lazy loading
  function initLazyLoading() {
    // Solo aplicar lazy loading a imágenes que específicamente lo requieran
    const lazyImages = document.querySelectorAll('img[data-src]');
    
    if (lazyImages.length === 0) {
      // No hay imágenes lazy, no hacer nada
      return;
    }
    
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            
            // Cargar imagen
            if (img.dataset.src) {
              img.src = img.dataset.src;
              img.removeAttribute('data-src');
            }
            
            // Cargar srcset si existe
            if (img.dataset.srcset) {
              img.srcset = img.dataset.srcset;
              img.removeAttribute('data-srcset');
            }
            
            // Añadir clase loaded
            img.classList.add('loaded');
            img.classList.remove('lazy');
            
            // Dejar de observar
            observer.unobserve(img);
          }
        });
      }, {
        rootMargin: PERFORMANCE_CONFIG.lazyLoadOffset,
        threshold: PERFORMANCE_CONFIG.intersectionThreshold
      });
      
      // Solo observar imágenes con data-src (lazy loading explícito)
      lazyImages.forEach(img => {
        imageObserver.observe(img);
      });
    } else {
      // Fallback para navegadores sin IntersectionObserver
      lazyImages.forEach(img => {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      });
    }
  }
  
  // Optimización de scroll performance
  function optimizeScrollPerformance() {
    let ticking = false;
    
    function updateScrollElements() {
      // Aquí se pueden añadir optimizaciones específicas de scroll
      ticking = false;
    }
    
    function requestTick() {
      if (!ticking) {
        requestAnimationFrame(updateScrollElements);
        ticking = true;
      }
    }
    
    window.addEventListener('scroll', requestTick, { passive: true });
  }
  
  // Preload de recursos críticos - Optimizado
  function preloadCriticalResources() {
    // Solo prefetch recursos que se van a usar después del load
    const futureResources = [
      '/js/home-search.js',
      '/js/featured-businesses.js'
    ];
    
    // Usar prefetch para recursos futuros (no preload)
    futureResources.forEach(resource => {
      // Verificar si el recurso ya existe
      if (!document.querySelector(`script[src="${resource}"]`) && 
          !document.querySelector(`link[href="${resource}"]`)) {
        const link = document.createElement('link');
        link.rel = 'prefetch'; // prefetch no causa warnings de preload
        link.href = resource;
        document.head.appendChild(link);
      }
    });
  }
  
  // Optimización de fuentes - Eliminado preload innecesario
  function optimizeFonts() {
    // Las fuentes ya están optimizadas con display=swap en el HTML
    // No necesitamos preload adicional que cause warnings
    
    // Solo verificar que las fuentes se carguen correctamente
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        console.log('[Performance] Fuentes cargadas correctamente');
      });
    }
  }
  
  // Reducir Layout Shift
  function reduceLayoutShift() {
    // Agrupar escrituras de estilo y cambios DOM en un frame para reducir reflows
    requestAnimationFrame(() => {
      // Añadir dimensiones a imágenes sin ellas
      document.querySelectorAll('img:not([width]):not([height])').forEach(img => {
        // Establecer aspect ratio por defecto
        img.style.aspectRatio = '16/9';
        img.style.objectFit = 'cover';
        img.style.width = '100%';
        img.style.height = 'auto';
      });
      
      // Reservar espacio para contenido dinámico
      document.querySelectorAll('.dynamic-content').forEach(element => {
        if (!element.style.minHeight) {
          element.style.minHeight = '200px';
        }
      });
      
      // Fijar dimensiones del hero para evitar CLS
      const heroContainer = document.querySelector('.hero-container');
      if (heroContainer && !heroContainer.style.minHeight) {
        heroContainer.style.minHeight = '400px';
        heroContainer.style.contain = 'layout';
      }
      
      // Reservar espacio para títulos móviles
      const mobileTitle = document.querySelector('.hero-title-mobile');
      if (mobileTitle) {
        mobileTitle.style.minHeight = '2.34rem';
        mobileTitle.style.contain = 'layout';
      }
      
      // Aplicar skeleton loading a elementos que cargan dinámicamente
      document.querySelectorAll('.fb-card:empty, .category-card:empty').forEach(element => {
        element.classList.add('skeleton');
      });
      
      // Observar cuando el contenido se carga para remover skeleton
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            mutation.target.classList.remove('skeleton');
          }
        });
      });
      
      document.querySelectorAll('.skeleton').forEach(element => {
        observer.observe(element, { childList: true });
      });
    });
  }
  
  // Optimización de Third-party scripts
  function optimizeThirdPartyScripts() {
    // Cargar scripts de terceros de forma diferida
    const thirdPartyScripts = document.querySelectorAll('script[src*="googleapis.com"], script[src*="cdnjs.cloudflare.com"]');
    
    thirdPartyScripts.forEach(script => {
      if (!script.hasAttribute('defer') && !script.hasAttribute('async')) {
        script.setAttribute('defer', '');
      }
    });
  }
  
  // Monitoreo de Core Web Vitals
  function monitorCoreWebVitals() {
    if ('web-vitals' in window) {
      // Si la librería web-vitals está disponible
      webVitals.getCLS(console.log);
      webVitals.getFID(console.log);
      webVitals.getFCP(console.log);
      webVitals.getLCP(console.log);
      webVitals.getTTFB(console.log);
    }
  }
  
  // Optimización de recursos críticos
  function optimizeCriticalResources() {
    // Mover scripts no críticos al final del body
    const nonCriticalScripts = document.querySelectorAll('script:not([data-critical])');
    nonCriticalScripts.forEach(script => {
      try {
        if (script.src && !script.src.includes('api-config') && !script.src.includes('performance-optimizer')) {
          if (!script.hasAttribute('defer') && !script.hasAttribute('async')) {
            script.setAttribute('defer', '');
          }
        }
      } catch(_) {}
    });
  }

  // Inicialización
  function init() {
    const runDeferred = () => {
      try { optimizeCriticalResources(); } catch(_) {}
      try {
        const runCLS = () => { try { reduceLayoutShift(); } catch(_) {} };
        if (document.readyState === 'complete') {
          setTimeout(runCLS, 0);
        } else {
          window.addEventListener('load', () => setTimeout(runCLS, 0), { once: true });
        }
      } catch(_) {}
    };

    try {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(runDeferred, { timeout: 2000 });
      } else {
        setTimeout(runDeferred, 2000);
      }
    } catch(_) {
      setTimeout(runDeferred, 2000);
    }

    const onDomReady = () => {
      initLazyLoading();
      optimizeScrollPerformance();
      optimizeThirdPartyScripts();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onDomReady, { once: true });
    } else {
      onDomReady();
    }

    window.addEventListener('load', () => {
      // Delay para evitar warnings de preload no usado
      setTimeout(() => {
        preloadCriticalResources();
        optimizeFonts(); // Mover aquí para evitar preload innecesario
        monitorCoreWebVitals();
      }, 1000);

      // Optimización post-carga
      setTimeout(() => {
        // Limpiar recursos no utilizados
        document.querySelectorAll('link[rel="preload"]').forEach(link => {
          // Solo remover si el recurso ya se cargó
          if (link.as === 'style' && link.sheet) {
            link.remove();
          } else if (link.as === 'script') {
            // Verificar si el script ya se ejecutó
            const script = document.querySelector(`script[src="${link.href}"]`);
            if (script) {
              link.remove();
            }
          }
        });
      }, 5000);
    }, { once: true });
  }

  // Inicializar optimizador
  init();

  // Exportar funciones para uso externo
  window.PerformanceOptimizer = {
    initLazyLoading,
    optimizeScrollPerformance,
    preloadCriticalResources,
    reduceLayoutShift
  };

})();